import { type useDispatch } from 'react-redux';

type CompleteNewLevelStepArgs = {
  data: {
    name?: string;
    level?: number;
  };
  currentStep: {
    id?: string;
    name?: string;
    level?: number;
  };
  dispatch: ReturnType<typeof useDispatch>;
};

const completeNewLevelStep = ({
  data,
  currentStep,
  dispatch,
}: CompleteNewLevelStepArgs): void => {
  if (
    !data.name ||
    !data.level ||
    !currentStep.id ||
    !currentStep.name ||
    !currentStep.level
  )
    return;

  if (data.name === currentStep.name && data.level === currentStep.level) {
    dispatch({
      type: 'authUser/completeStepToNewLevel',
      payload: currentStep.id,
    });
  }
};

export { completeNewLevelStep };
